import { useWindowSize } from '@vueuse/core'

export default defineNuxtRouteMiddleware((to) => {
    const { $i18n } = useNuxtApp()
    const { SEARCH_PAGE_PREFIX, BREAKPOINTS, URL_CUSTOMER_ORDERS, URL_USER_DASHBOARD } = useAppConfig()
    const { width } = useWindowSize()

    const { path, query, hash } = to

    if (path !== '/' && path.endsWith('/') && path.substring(3) !== `/${SEARCH_PAGE_PREFIX}/`) {
        const nextPath = path.replace(/\/+$/, '') || '/'
        const nextRoute = { path: nextPath, query, hash }

        return navigateTo(nextRoute, { redirectCode: 301 })
    }

    if (query.page === '1') {
        // eslint-disable-next-line unused-imports/no-unused-vars
        const { page, ...newQuery } = query

        const nextRoute = { path, query: newQuery, hash }

        return navigateTo(nextRoute, { redirectCode: 301 })
    }

    if (path === `/${$i18n.locale.value}${URL_USER_DASHBOARD}` && width.value > BREAKPOINTS.lg) {
        return navigateTo(`/${$i18n.locale.value}${URL_CUSTOMER_ORDERS}`, { redirectCode: 301 })
    }
})
